import { createContext } from 'react';

export const defaultCt = {
    textView: {
        color: "#121212"
    },
    paginationTable: {
        images: {
            loading: "",
            empty: "",
        }
    },
    
}
export const ThemeContext = createContext(defaultCt)